<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基础信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="课程名称">{{form.name}}</el-descriptions-item>
        <el-descriptions-item label="福利类型" v-if="sourceType === 1">{{form.welfareName}}</el-descriptions-item>
        <el-descriptions-item label="课程分类" v-if="sourceType === 2">{{form.className}}</el-descriptions-item>
        <el-descriptions-item label="封面图"><el-image style="width: 50px; height: 50px" :src="form.coverImage" :preview-src-list="[form.coverImage]"></el-image></el-descriptions-item>
        <el-descriptions-item label="讲师" v-if="form.type === 2">{{form.realName}}</el-descriptions-item>
        <el-descriptions-item label="播放/浏览量">{{form.playNum}}</el-descriptions-item>
        <el-descriptions-item label="点赞量">{{form.likeNum}}</el-descriptions-item>
        <el-descriptions-item label="收藏量">{{form.collectNum}}</el-descriptions-item>
        <el-descriptions-item label="转发量">{{form.forwardNum}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{form.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{form.state?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">课程配置</span></div>
      <el-descriptions :column="1">
        <el-descriptions-item label="课程类型">{{form.type === 1?'图文':'视频'}}</el-descriptions-item>
        <el-descriptions-item label="课程介绍" v-if="form.type === 2">
          <div v-html="form.introduce"></div>
        </el-descriptions-item>
        <el-descriptions-item label="课程内容" v-if="form.type === 1">
          <div v-html="form.content"></div>
        </el-descriptions-item>
        <el-descriptions-item label="课程" v-if="form.type === 2"></el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">考试配置</span></div>
      <el-descriptions>
        <el-descriptions-item label="是否考试">{{form.isExam?'考试':'不考试'}}</el-descriptions-item>
        <template v-if="form.isExam">
          <el-descriptions-item label="考试题目">{{form.topicClassificationName}}</el-descriptions-item>
          <el-descriptions-item label="考试题数">{{form.examNum}}题</el-descriptions-item>
          <el-descriptions-item label="单题分数">{{form.examSingleScore}}分</el-descriptions-item>
          <el-descriptions-item label="总分">{{form.examTotalScore}}分</el-descriptions-item>
          <el-descriptions-item label="考试达标分数">{{form.achievementScore}}分</el-descriptions-item>
          <el-descriptions-item label="考试学分">{{form.examCredits}}学分</el-descriptions-item>
          <el-descriptions-item label="是否能看答案">{{form.isLookSolution?'允许查看':'不允许查看'}}</el-descriptions-item>
          <el-descriptions-item label="考试次数">{{form.examOrder}}次</el-descriptions-item>
          <el-descriptions-item label="考试时长">{{form.examDuration}}分钟</el-descriptions-item>
          <el-descriptions-item label="考试规则">{{form.examRules?'学习完考':'不限制'}}</el-descriptions-item>
        </template>
      </el-descriptions>
      <template v-if="form.type === 2">
        <el-table :data="form.courseSubjectVideoList">
          <el-table-column label="章节节数" prop="chaptersNum" align="center" />
          <el-table-column label="章节名称" prop="name" align="center" />
          <el-table-column label="封面图" align="center">
            <template slot-scope="{row}">
              <el-image style="width: 50px; height: 50px" v-if="row.coverImage" :src="row.coverImage" :preview-src-list="[row.coverImage]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="视频课" prop="videoUrl" align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="handleOpenLink(row)">{{row.videoUrl}} </el-link><el-link type="primary" @click="handleDownloadVideo(row)">下载</el-link>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" prop="createdTime" align="center" />
          <el-table-column label="状态" prop="name" align="center">
            <template slot-scope="{row}">
              {{row.state?'启用':'禁用'}}
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="operatedTime" align="center" />
          <el-table-column label="操作人" prop="operatedBy" align="center" />
        </el-table>
        <div class="title-box"><span class="txt1">课件</span></div>
        <el-table :data="form.courseSubjectWaresList">
          <el-table-column label="课件" align="center">
            <template slot-scope="{row}">
              {{row.wareUrl}} <el-link type="primary" @click="handleDownload(row)">下载</el-link>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" prop="createdTime" align="center" />
          <el-table-column label="状态" align="center">
            <template slot-scope="{row}">
              {{row.state?'启用':'禁用'}}
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="operatedTime" align="center" />
          <el-table-column label="操作人" prop="operatedBy" align="center" />
        </el-table>
        <div class="title-box"><span class="txt1">修复方案</span></div>
        <div v-for="(item,index) in form.courseSubjectRepairPlanList" :key="index">
          <div>方案{{index + 1}}</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="修复方案名称">{{item.name}}</el-descriptions-item>
            <el-descriptions-item label="封面图"><el-image style="width: 50px; height: 50px" :src="item.coverImage" :preview-src-list="[item.coverImage]"></el-image></el-descriptions-item>
            <el-descriptions-item label="方案介绍">{{item.introduce}}</el-descriptions-item>
            <el-descriptions-item label="状态">{{item.state?'启用':'禁用'}}</el-descriptions-item>
            <el-descriptions-item label="修改时间">{{item.operatedTime}}</el-descriptions-item>
            <el-descriptions-item label="操作人">{{item.operatedBy}}</el-descriptions-item>
            <el-descriptions-item label="详情">
              <div v-html="item.introduce"></div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </template>
    </el-card>
  </div>
</template>

<script>
import courseSubjectApi from '@/api/course/courseSubject'
export default {
  props: ['rowItem', 'sourceType'],
  data() {
    return {
      form: null,
    }
  },
  created() {
    this.getDeatils()
  },
  methods: {
    getDeatils() {
      courseSubjectApi.fetchById(this.rowItem.id).then(res => {
        let data = res.data;
        let arr = []
        data.courseClassificationVOList.forEach(itt => {
          arr.push(itt.typeName + (itt.courseClassificationVO ? '>' + itt.courseClassificationVO.typeName : '') +
            (itt.courseClassificationVO && itt.courseClassificationVO.courseClassificationVO ? '>' + itt.courseClassificationVO.courseClassificationVO.typeName : ''))
        })
        if (arr.length > 0) data.className = arr.toString()
        this.form = data
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    //下载
    handleDownload(item) {
      let url = item.wareUrl
      if (!url) return
      let type = url.substr(url.lastIndexOf('.') + 1)
      let fileName = url.substr(url.lastIndexOf('/') + 1)
      if (type === 'pdf') {
        fetch(url).then(response => response.blob()).then(blob => {
          // 创建一个临时的URL对象
          const url = URL.createObjectURL(blob);
          // 创建一个隐藏的<a>标签，并设置其href属性为临时URL
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.style.display = 'none';
          // 将<a>标签添加到文档中，并模拟点击下载
          document.body.appendChild(a);
          a.click();
          // 下载完成后，移除<a>标签和临时URL对象
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }).catch(error => {
          console.error('下载文件时出错:', error);
        });
      } else {
        let a = document.createElement('a')
        a.href = url
        a.click();
      }
    },
    handleDownloadVideo(item) {
      var url = item.videoUrl //视频链接
      if (!url) return
      //跳过浏览直接下载
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const a = document.createElement("a");
          const objectUrl = window.URL.createObjectURL(blob);
          a.download = '课程视频';
          a.href = objectUrl;
          a.click();
        })
    },
    handleOpenLink(row) {
      if (!row.videoUrl) return
      window.open(row.videoUrl, '_blank');
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
</style>
